<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-10 20:10:09
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-01 09:39:03
-->
<template>
	<el-input-number
		v-model="value"
		@change="changeSkuNumbs(value, row)"
		:min="0"
		label="描述文字"
		v-if="row.specification"
		size="mini"
		controls-position="right"
	></el-input-number>
	<span v-else>-</span>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	inject: ['changeSkuNumbs'],
	data() {
		return {
			value: this.cellValue,
		};
	},
	mounted() {
		this.value = this.cellValue;
	},
	watch: {
		cellValue(val) {
			this.value = val;
		},
	},
};
</script>
<style lang="less">
.el-input-number--mini {
	width: 80px;
}
</style>
